import React from 'react'
import ComplementaryReviewInfo from 'components/ManualAnalysisList/ComplementaryReviewInfo'
import ReviewsList from 'components/ManualAnalysisList/ReviewsList'
import Container from './styles'

function ReviewAnalysis(props) {
  const { checkType, reviewData, onDataChanged } = props
  const key = checkType === false ? 'background_check' : 'reference_check'
  return (
    <Container>

      <ComplementaryReviewInfo review={reviewData} check={reviewData[key]} />

      <ReviewsList reviews={[reviewData]} reviewCheckType={checkType === false ? 'bgc' : 'rfc'} onDataChanged={onDataChanged} />

    </Container>
  )
}

export default ReviewAnalysis
